module.exports = __webpack_public_path__ + "images/husqvarna_small831be64fd51a1ca886254cc09ea4ac58.png";